// 删除提示框
import Notice from '@/utils/notice.base';
const notice = new Notice();

function deleteConfirm (successCall) {
    let method = "confirm";
    let title = "Delete Warning";
    let message = "Are you sure you want to delete this data ?";
    let type = 'warning';
    notice.messageBox(method, message, title, type)(successCall);
}

export { deleteConfirm };